import { AVG, PERCENTILES, SUM } from 'reporting-data/constants/metricTypes';
import { COLOR, colors } from 'reporting-ui-components/constants/colors';
export const ALL_METRICS = {
  rawViews: {
    metricTypes: [SUM],
    labelKey: 'page-details-ui.reporting.metrics.rawViews',
    tooltipKey: 'page-details-ui.reporting.metrics.tooltips.rawViews'
  },
  submissions: {
    metricTypes: [SUM],
    labelKey: 'page-details-ui.reporting.metrics.submissions',
    tooltipKey: 'page-details-ui.reporting.metrics.tooltips.submissions'
  },
  contacts: {
    metricTypes: [SUM],
    labelKey: 'page-details-ui.reporting.metrics.contacts',
    tooltipKey: 'page-details-ui.reporting.metrics.tooltips.contacts'
  },
  contactToCustomerRate: {
    metricTypes: [PERCENTILES],
    labelKey: 'page-details-ui.reporting.metrics.contactToCustomerRate'
  },
  customers: {
    metricTypes: [SUM],
    labelKey: 'page-details-ui.reporting.metrics.customers',
    tooltipKey: 'page-details-ui.reporting.metrics.tooltips.customers'
  },
  pageBounceRate: {
    metricTypes: [AVG],
    labelKey: 'page-details-ui.reporting.metrics.pageBounceRate',
    tooltipKey: 'page-details-ui.reporting.metrics.tooltips.pageBounceRate'
  },
  timePerPageview: {
    metricTypes: [PERCENTILES],
    labelKey: 'page-details-ui.reporting.metrics.timePerPageview',
    tooltipKey: 'page-details-ui.reporting.metrics.tooltips.timePerPageview'
  },
  exitsPerPageview: {
    metricTypes: [PERCENTILES],
    labelKey: 'page-details-ui.reporting.metrics.exitsPerPageview',
    tooltipKey: 'page-details-ui.reporting.metrics.tooltips.exitsPerPageview'
  },
  entrances: {
    metricTypes: [SUM],
    labelKey: 'page-details-ui.reporting.metrics.entrances',
    tooltipKey: 'page-details-ui.reporting.metrics.tooltips.entrances'
  },
  exits: {
    metricTypes: [SUM],
    labelKey: 'page-details-ui.reporting.metrics.exits'
  },
  submissionsPerPageview: {
    metricTypes: [PERCENTILES],
    labelKey: 'page-details-ui.reporting.metrics.submissionsPerPageview'
  },
  contactsPerPageview: {
    metricTypes: [PERCENTILES],
    labelKey: 'page-details-ui.reporting.metrics.contactsPerPageview'
  },
  customersPerPageview: {
    metricTypes: [PERCENTILES],
    labelKey: 'page-details-ui.reporting.metrics.customersPerPageview'
  }
};
export const DEFAULT_METRICS_TO_DISPLAY = ['rawViews', 'submissions', 'contacts', 'contactToCustomerRate', 'customers', 'pageBounceRate', 'timePerPageview'];
export const METRICS_TO_DISPLAY_IN_DATA_WELL = ['rawViews', 'submissions', 'contacts', 'customers', 'pageBounceRate', 'timePerPageview', 'exitsPerPageview', 'entrances'];
export const DEFAULT_VARIATION_METRICS_TO_DISPLAY = ['rawViews', 'submissions', 'submissionsPerPageview', 'contactsPerPageview', 'customersPerPageview', 'pageBounceRate', 'timePerPageview'];
export const MAB_VARIATION_COLORS = [colors.get(COLOR.ORANGE), colors.get(COLOR.PURPLE), colors.get(COLOR.YELLOW), colors.get(COLOR.PINK), colors.get(COLOR.AQUA)];